var map = {
	"./dk/gronborg_round.jpg": 1159,
	"./dk/gronborg_square.jpg": 1160,
	"./dk/handbold_round.png": 1161,
	"./dk/handbold_square.jpg": 1162,
	"./dk/levy_round.png": 1163,
	"./dk/levy_square.jpg": 1164,
	"./dk/molby_round.jpg": 1165,
	"./dk/molby_square.jpg": 1166,
	"./dk/ortved_round.jpg": 1167,
	"./dk/ortved_square.jpg": 1168,
	"./dk/peter_schulz_round.jpg": 1169,
	"./dk/peter_schulz_square.jpg": 1170,
	"./fi/betting_round.png": 1171,
	"./fi/betting_square.jpg": 1172,
	"./fi/jouni-nieminen_round.png": 1173,
	"./fi/jouni-nieminen_square.jpg": 1174,
	"./no/NFLPodcast_round.jpg": 1175,
	"./no/NFLPodcast_square.jpg": 1176,
	"./no/NHLprat_round.png": 1177,
	"./no/NHLprat_square.png": 1178,
	"./no/championsleague_round.png": 1179,
	"./no/championsleague_square.jpg": 1180,
	"./no/daniel_hoglund_round.jpg": 1181,
	"./no/daniel_hoglund_square.jpg": 1182,
	"./no/laliga_round.png": 1183,
	"./no/laliga_square.png": 1184,
	"./no/motor_round.png": 1185,
	"./no/motor_square.png": 1186,
	"./no/nornfl_round.png": 1187,
	"./no/nornfl_square.png": 1188,
	"./no/stokke_round.png": 1189,
	"./no/stokke_square.png": 1190,
	"./se/bojan_round.png": 1191,
	"./se/bojan_square.png": 1192,
	"./se/hockey_round.png": 1193,
	"./se/hockey_square.jpg": 1194,
	"./se/janne_round.png": 1195,
	"./se/janne_square.png": 1196,
	"./se/jihde_round.png": 1197,
	"./se/jihde_square.png": 1198,
	"./se/motor_round.png": 1199,
	"./se/motor_square.png": 1200,
	"./se/silly_round.jpg": 1201,
	"./se/silly_square.jpg": 1202
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 942;


//////////////////
// WEBPACK FOOTER
// ./assets/media-images ^\.\/.*$
// module id = 942
// module chunks = 1 2